import { render } from "./OrderTrackingPage.vue?vue&type=template&id=585268e2&ts=true"
import script from "./OrderTrackingPage.vue?vue&type=script&lang=ts"
export * from "./OrderTrackingPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__